import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface UseGameExitPreventionProps {
  enabled: boolean;
  message?: string;
}

/**
 * 게임 진행 중 페이지 이탈 방지 훅
 * - 브라우저 새로고침/닫기 방지
 * - Next.js 라우터 변경 방지
 */
export const useGameExitPrevention = ({
  enabled,
  message = '게임이 진행 중입니다. 정말 나가시겠습니까?',
}: UseGameExitPreventionProps) => {
  const router = useRouter();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    // 브라우저 새로고침/닫기 방지
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // 최신 브라우저에서는 returnValue 설정이 필요
      e.returnValue = message;
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    // Next.js 라우터 변경 방지
    const handleRouteChangeStart = (url: string) => {
      // 현재 페이지와 다른 경로로 이동 시도 시에만 막기
      if (router.asPath !== url && !window.confirm(message)) {
        router.events.emit('routeChangeError');
        // eslint-disable-next-line no-throw-literal
        throw 'Route change aborted by user';
      }
    };

    router.events.on('routeChangeStart', handleRouteChangeStart);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      router.events.off('routeChangeStart', handleRouteChangeStart);
    };
  }, [enabled, message, router]);
};
